import React, {useMemo, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {isEqual} from 'lodash';
import {Formik} from 'formik';
import {useInvoicesUIContext} from '../InvoicesUIContext';

const SortingColumnHeader = ({header, defaultMessage, fieldName}) => {
  const qs = new URLSearchParams(window.location.search);
  const sortByOrder = qs.get('sortByOrder') || '';
  const sortByField = qs.get('sortByField') || '';

  const [orderType, setOrderType] = useState(1);
  const prepareFilter = (queryParams, values) => {
    const {sortByOrder, sortByField} = values;
    const newQueryParams = {...queryParams};
    const filter = {};
    if (sortByOrder !== '') {
      filter.sortByOrder = sortByOrder;
    } else {
      delete newQueryParams.sortByOrder;
    }
    if (sortByField !== '') {
      filter.sortByField = sortByField;
    } else {
      delete newQueryParams.sortByField;
    }
    return {...newQueryParams, ...filter};
  };
  const invoicesUIContext = useInvoicesUIContext();
  const invoicesUIProps = useMemo(() => {
    return {
      queryParams: invoicesUIContext.queryParams,
      setQueryParams: invoicesUIContext.setQueryParams,
    };
  }, [invoicesUIContext]);
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(invoicesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, invoicesUIProps.queryParams)) {
      invoicesUIProps.setQueryParams(newQueryParams);
    }
  };

  const showInitialArrow = sortByField === '' && sortByOrder === '' && fieldName === 'datetime';
  const iconToShow = sortByOrder === '1'
    ? '/media/svg/Arrow-top.svg'
    : '/media/svg/Arrow-down_brandColor.svg';

  return (
    <Formik
      initialValues={{
        sortByOrder,
        sortByField,
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
      enableReinitialize={true}
    >
      {({
          handleSubmit,
          setFieldValue,
        }) => (
        <form onSubmit={handleSubmit} className="d-flex position-relative">
          <div
            className="cursor-pointer"
            onClick={() => {
              (orderType === -1) ? setOrderType(1) : setOrderType(-1)
              setFieldValue('sortByOrder', orderType);
              setFieldValue('sortByField', fieldName);
              handleSubmit();
            }}
          >
            <FormattedMessage
              id={header}
              defaultMessage={defaultMessage}
            />
          </div>
          <div className="ml-2 w-30px">
            {showInitialArrow
              ? (
                <div className="d-flex position-absolute right-5">
                  <img
                    src={toAbsoluteUrl('/media/svg/Arrow-down_brandColor.svg')}
                    alt="sort-ascending"
                    className="w-20px"
                  />
                </div>
              )
              : (
                <>
                  {(sortByField === fieldName) ?
                    <div className="d-flex position-absolute right-5">
                      <img
                        src={toAbsoluteUrl(iconToShow)}
                        alt="sort"
                        className="w-20px"
                      />
                    </div>
                    : ''}
                </>
              )
            }
          </div>
        </form>
      )}
    </Formik>
  )
};

export default SortingColumnHeader;